import { useMemo } from "react";
import { Container, Heading2, Tabs } from "shared/components";
import { TabsProvider } from "shared/components/Tabs/Tabs.Provider";

import styles from "./Content010.module.scss";
import { serializeItem } from "./Content010.utils.js";
import YearsView from "./YearsView/YearsView";

export const Content010 = ({ payload }) => {
  const title = payload?.title ?? "";
  const historyPeriods = useMemo(
    () => payload?.historyPeriods ?? [],
    [payload]
  );

  const extractedTabYears = historyPeriods.map((item) => serializeItem(item));

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <div className={styles.header}>
          <Heading2>{title}</Heading2>
        </div>
        <TabsProvider items={extractedTabYears} tabsEnabled={true}>
          <div className={styles.blocks}>
            <div className={styles.tabs}>
              <Tabs tabType="tab-years" />
            </div>
            <YearsView items={historyPeriods} />
          </div>
        </TabsProvider>
      </Container>
    </div>
  );
};

export default Content010;
